// ACTIONS

export const ACTION_GET_FILES_ITEM_REQUEST = '@actions/FILES/GET_REQUEST'
export const ACTION_GET_FILES_ITEM_SUCCESS = '@actions/FILES/GET_SUCCESS'
export const ACTION_GET_FILES_ITEM_FAILURE = '@actions/FILES/GET_FAILURE'

export const ACTION_UPLOAD_FILES_ITEM_REQUEST = '@actions/FILES/UPLOAD_REQUEST'
export const ACTION_UPLOAD_FILES_ITEM_SUCCESS = '@actions/FILES/UPLOAD_SUCCESS'
export const ACTION_UPLOAD_FILES_ITEM_FAILURE = '@actions/FILES/UPLOAD_FAILURE'

// ERRORS
export const ERROR_FILES_UPLOAD_SERVER = 'Failed to upload file. Please try again later.'
export const ERROR_BULK_FILES_UPLOAD_SERVER = 'Failed to upload files. Please try again later.'
